import { styled } from "@woba/ds-web";

export const ChartWrapper = styled("div", {
  width: "100%",
});

export const ActionButtonsUsageContainers = styled("div", {});
